module.exports = __webpack_public_path__ + "img/C1_HQ03.7c869000.jpg";